'use client'

import { createContext, ReactNode, useContext, useState } from 'react'

interface BodyCentralContextProps {
    scrollable: boolean
    setScrollable: (availability: boolean) => void
}

const BodyCentralContext = createContext<BodyCentralContextProps | undefined>(undefined)

export const BodyCentralProvider = ({ children }: { children: ReactNode }) => {
    const [scrollable, setScrollable] = useState(true)

    return (
        <BodyCentralContext.Provider
            value={{
                scrollable,
                setScrollable,
            }}
        >
            {children}
        </BodyCentralContext.Provider>
    )
}

export const useBodyCentral = (): BodyCentralContextProps => {
    const context = useContext(BodyCentralContext)
    if (!context) throw new Error('useBodyCentral must be used within a BodyCentralProvider')
    return context
}
